import React from 'react';
import { Container } from 'semantic-ui-react';

const Footer = () => {
  return (
    <footer
      className="site-footer esgld-footer"
      id="footer"
      role="contentinfo"
      aria-label="Website footer"
    >
      <Container>
        <div className="footer-content">
          <h2 id="footer-heading" className="footer-title">
            Contact ESGLD
          </h2>

          <p className="contact-name">Nicolina Cristina Sorrentino, PhD</p>

          <div className="footer-columns">
            <div className="footer-col left">
              <address
                className="contact-address"
                aria-label="Institution address"
              >
                Telethon Institute of Genetics and Medicine
                <br />
                Via Campi Flegrei 34
                <br />
                80078 Pozzuoli (NA), Italy
              </address>
            </div>

            <div className="footer-col right">
              <p>
                <span>Phone: </span>
                <a
                  href="tel:+3908119230649"
                  aria-label="Call ESGLD at plus three nine zero eight one one nine two three zero six four nine"
                >
                  +39 081 1923 0649
                </a>
              </p>
              <p>
                <span>Email: </span>
                <a
                  href="mailto:secretary@esgld.org"
                  aria-label="Send email to secretary at esgld dot org"
                >
                  secretary@esgld.org
                </a>
              </p>
            </div>
          </div>

          <nav
            className="footer-legal"
            aria-label="Legal links and policies"
          >
            <a href="/legal-notice/" aria-label="Read our legal notice">
              Legal Notice
            </a>
            <span className="sep" aria-hidden="true">
              |
            </span>
            <a href="/privacy-policy" aria-label="Read our privacy policy">
              Privacy Policy
            </a>
          </nav>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
